import Router from "./route/Index";
import ThemeProvider from "./layout/provider/Theme";
import { I18nextProvider } from "react-i18next";
import i18next from "./assets/constants/i18n";

const App = () => {
  return (
    <I18nextProvider i18n={i18next}>
      <ThemeProvider>
        <Router />
      </ThemeProvider>
    </I18nextProvider>
  );
};
export default App;
